// The peeks at issues and pull requests (logic/refPeek.ts), by Links-card
// key, kept PEEK_TTL_MS, and dropped when another account signs in.
import { graphqlResult } from '../api/gh';
import { onIdentityChange } from '../api/identity';
import { readRefPeek, REF_PEEK_QUERY, type RefPeek } from '../logic/refPeek';

/** How long a peek is shown before it is asked for again. */
const PEEK_TTL_MS = 5 * 60_000;
/** Peeks kept at most. */
const MAX = 200;

let held = new Map<string, { at: number; peek: Promise<RefPeek | null> }>();
onIdentityChange(() => (held = new Map()));

/** The peek at `owner/repo#number` (keyed `key`): null when GitHub has none for the viewer. A failed request is not kept. */
export function loadRefPeek(key: string, ref: { owner: string; repo: string; number: number }): Promise<RefPeek | null> {
  const h = held.get(key);
  if (h && Date.now() - h.at < PEEK_TTL_MS) return h.peek;
  const peek = graphqlResult(REF_PEEK_QUERY, { o: ref.owner, n: ref.repo, num: ref.number }, { partial: true }).then((res) => readRefPeek(res.data));
  held.delete(key);
  held.set(key, { at: Date.now(), peek });
  peek.catch(() => held.get(key)?.peek === peek && held.delete(key));
  while (held.size > MAX) held.delete(held.keys().next().value!);
  return peek;
}
